import { websocket } from '@playcastdotio/Messaging';
import type { LiveOpsEventPayload } from '@playcastdotio/Messaging';
import { sendMessage } from '../../../api/modules/realtimeMessaging';

/**
 * Transport seam for LiveOps emission. Injected into the manager so the emitter
 * can be unit-tested without a live socket. The concrete implementation reuses
 * the realtime outbox: `sendMessage` queues into `messageQueue` and flushes on
 * `setIsReady(true)`, so events fired before auth are buffered, not lost.
 */
export interface ILiveOpsTransport {
  /** Sends a LIVEOPS_EVENT; buffers via the realtime outbox if the socket is not ready. */
  sendEvent(payload: LiveOpsEventPayload): void;
}

export class RealtimeLiveOpsTransport implements ILiveOpsTransport {
  sendEvent(payload: LiveOpsEventPayload): void {
    sendMessage(websocket.generators.liveOpsEvent(payload));
  }
}
